import { createUniversalStorage } from '../storage/index.js';
import { isWeb } from '../platform.js';

class AuthCustomStorage {
    async setItem(key, value) {
        await AuthCustomStorage.storage.setItem(key, value);
    }
    async getItem(key) {
        const value = await AuthCustomStorage.storage.getItem(key);
        return value ?? null;
    }
    async removeItem(key) {
        await AuthCustomStorage.storage.removeItem(key);
    }
    async clear() {
        await AuthCustomStorage.storage.clear();
    }
    getAllValues() {
        // Fallback implementation since KeyValueStorageInterface doesn't have getAllValues
        try {
            // Try to call getAllValues if it exists (for ReactNative storage)
            if ('getAllValues' in AuthCustomStorage.storage && typeof AuthCustomStorage.storage.getAllValues === 'function') {
                return AuthCustomStorage.storage.getAllValues();
            }
        } catch (error) {
            console.warn('getAllValues not supported on this platform:', error);
        }
        // Return empty array for platforms that don't support getAllValues
        return [];
    }
}
AuthCustomStorage.storage = createUniversalStorage({
    name: isWeb() ? '' : 'quince-auth-store',
    preserveKeysEnabled: true,
    preserveKeys: []
});

export { AuthCustomStorage };
//# sourceMappingURL=AuthCustomStorage.js.map
